"use client"

import { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import "./Home.css"
import ProfilePic from './images/profile.jpg';
import ProjectPic from './images/yacsaf.PNG';

const Home = () => {
  const textRef = useRef(null)

  useEffect(() => {
    // Create the observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in")
          }
        })
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
    )

    // Observe all elements with animate class
    const elements = document.querySelectorAll(".animate")
    elements.forEach((el) => observer.observe(el))

    return () => {
      elements.forEach((el) => observer.unobserve(el))
    }
  }, [])

  useEffect(() => {
    if (textRef.current) {
      const text = "I build things for the web."
      const element = textRef.current
      let index = 0
      element.textContent = "";

      const typeWriter = () => {
        if (index < text.length) {
          if (text.charAt(index) == element.textContent.charAt(element.textContent.length)) {
            return setTimeout(typeWriter, 100);
          }
          element.textContent += text.charAt(index);
          index++;
          setTimeout(typeWriter, 100);
        }
      }

      setTimeout(() => {
        typeWriter()
      }, 1000)
    }
  }, [])

  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-grid">
            <div className="hero-text">
              <h1 className="animate">
                Hello, I'm <span className="highlight">Safwen Aichy</span>
              </h1>
              <h2 className="subtitle" ref={textRef}></h2>
              <p className="description animate" style={{ animationDelay: "0.3s" }}>
                Motivated and versatile Software Engineer with a strong foundation in full-stack web development, IoT systems, and software engineering principles. 
                <br></br>
                <br></br>
                Welcome to my portfolio! Here, you'll find a showcase of my projects, skills, and experiences. 
              </p>
              <div className="cta-buttons animate" style={{ animationDelay: "0.6s" }}>
                <Link to="/projects" className="cta-button primary">
                  View My Work
                </Link>
                <Link to="/contact" className="cta-button secondary">
                  Get In Touch
                </Link>
              </div>
            </div>
            <div className="profile-image-container animate" style={{ animationDelay: "0.4s" }}>
              <div className="profile-image">
                <img src={ProfilePic} alt="Profile" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="skills-section animate">
        <h2>My Skills</h2>
        <div className="skills-container">
          <div className="skill-card">
            <div className="skill-icon">
              <i className="fab fa-react"></i>
            </div>
            <h3>Frontend Development</h3>
            <p>Creating responsive and interactive user interfaces with modern frameworks.</p>
          </div>

          <div className="skill-card">
            <div className="skill-icon">
              <i className="fas fa-server"></i>
            </div>
            <h3>Backend Development</h3>
            <p>Building robust server-side applications and APIs.</p>
          </div>

          <div className="skill-card">
            <div className="skill-icon">
              <i className="fas fa-microchip"></i>
            </div>
            <h3>IoT Solutions</h3>
            <p>Developing cutting edge IoT Solutions.</p>
          </div>
        </div>
      </section>

      <section className="featured-project animate">
        <h2>Featured Project</h2>
        <div className="project-showcase">
          <div className="project-image">
            <img src={ProjectPic} alt="Featured project" />
          </div>
          <div className="project-info">
            <h3>Face Recognition IoT Solution</h3>
            <p>
              • Developed a complete Internet of Things (IoT) solution for personnel identification using Microsoft Azure cloud services and facial recognition.<br></br>
              • Logged user access data into a secure database and designed a web-based admin dashboard for data management.<br></br>
              • Emphasized secure authentication, real-time data handling, and cloud deployment.
            </p>
            <div className="project-tech">
              <span>Python</span>
              <span>Microsoft Azure - Azure IoT</span>
              <span>OpenCV</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
